// extracted by mini-css-extract-plugin
export default {"toolbar":"gGfiIoA0U7OogwuqLXTl","toolbarButtons":"tyDQOwSLuJmIQdw4e74H","materialIcons":"Sb4tVKkYbTvDfXcT87vh"};